import { legalIdentityFromEnvironment, type LegalIdentityConfig } from "./legal";

export interface RuntimeConfig {
  publicSiteUrl: string;
  apiBaseUrl: string | null;
  useLocalFixtures: boolean;
  extensionInstallUrl: string | null;
  legalIdentity: LegalIdentityConfig;
}

function secureHttpUrl(value: string | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== "https:") return null;
    return url.toString().replace(/\/$/, "");
  } catch {
    return null;
  }
}

export function createRuntimeConfig(
  env: ImportMetaEnv,
  development: boolean,
): RuntimeConfig {
  return {
    publicSiteUrl: secureHttpUrl(env.VITE_PUBLIC_SITE_URL) ?? "https://tucui.c-jayden.com",
    apiBaseUrl: secureHttpUrl(env.VITE_API_BASE_URL),
    useLocalFixtures: development && env.VITE_USE_LOCAL_FIXTURES === "true",
    extensionInstallUrl: secureHttpUrl(env.VITE_EXTENSION_INSTALL_URL),
    legalIdentity: legalIdentityFromEnvironment(env),
  };
}

export const runtimeConfig = createRuntimeConfig(import.meta.env, import.meta.env.DEV);
